// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import translate from "@insite/client-framework/Translate";
import { createSectionTitleWidget, SectionTitleStyles } from "@mcmc/App/Widgets/SectionTitleWidget/SectionTitleWidget";
import Cart from "@mcmc/XDL/Icons/Cart";
import { css } from "styled-components";

const columnContentWidth = 370;
const gap = 30;

export const checkoutContainer = {
    width: columnContentWidth * 2 + gap,
    columnWidth: columnContentWidth,
    gap,
};

export enum CheckoutStepKey {
    cart = "cart",
    addresses = "addresses",
    payment = "payment",
    shipping = "shipping",
    review = "review",
}

export interface CheckoutStep {
    key: CheckoutStepKey;
    title: string;
    index: number;
    icon?: React.FC;
    titleDisplay?: ReturnType<typeof createSectionTitleWidget>;
    isDisabled?: boolean;
    onClickHandler?: () => void;
    validate: () => Promise<boolean>;
}

const sectionTitleStyle: SectionTitleStyles = {
    wrapper: {
        css: css`
            margin-bottom: 30px;
        `,
    },
};

function createInitalCheckoutStep(key: CheckoutStepKey, title: string, icon?: React.FC): CheckoutStep {
    return {
        index: 0,
        key,
        title,
        icon,
        validate: () => {
            return new Promise(resolve => resolve(true));
        },
    };
}

const cartStep: CheckoutStep = createInitalCheckoutStep(CheckoutStepKey.cart, "", Cart);
const addressesStep: CheckoutStep = createInitalCheckoutStep(CheckoutStepKey.addresses, translate("Addresses"));
const shippingStep: CheckoutStep = createInitalCheckoutStep(CheckoutStepKey.shipping, translate("Shipping"));
const paymentStep: CheckoutStep = createInitalCheckoutStep(CheckoutStepKey.payment, translate("Payment"));
const reviewStep: CheckoutStep = createInitalCheckoutStep(CheckoutStepKey.review, translate("Review"));

const checkoutSteps: {
    [key: string]: CheckoutStep[];
} = {
    [FulfillmentMethod.PickUp]: [cartStep, addressesStep, paymentStep, reviewStep],
    [FulfillmentMethod.Ship]: [cartStep, addressesStep, shippingStep, paymentStep, reviewStep],
};

export const getCheckoutSteps = (FulfillmentMethod: string) => {
    const steps = checkoutSteps[FulfillmentMethod];
    steps.every((step, i) => {
        step.index = i;
        step.titleDisplay = createSectionTitleWidget(step.title, undefined, undefined, sectionTitleStyle);
        return true;
    });
    return steps;
};
